export interface IDateDrillDownSelectedItem {
    periodLabel: string;
    periodType: string;
    periodMonth: Date;
    periodStart: Date;
    periodEnd: Date;
  }

export class DateDrillDownSelectedItem implements IDateDrillDownSelectedItem {

    periodLabel: string;
    periodType: string;
    periodMonth: Date;
    periodStart: Date;
    periodEnd: Date;

    constructor(periodLabel: string, periodType: string, periodMonth: Date, periodStart: Date, periodEnd: Date) {
        this.periodLabel = periodLabel;
        this.periodType = periodType;
        this.periodMonth = periodMonth;
        this.periodStart = periodStart;
        this.periodEnd = periodEnd;
    }
}
